module.exports = __webpack_public_path__ + "b408a022.svg";